// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_RATINGS = ["%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed", "%(counter)s hodnocen\u00ed"];
export const PRODUCT_BOX_WRITE_REVIEW = "Nap\u00ed\u0161 hodnocen\u00ed";
export const STROLLER_BOX_ESHOP_BUTTON_LABEL = "Do eshopu";
export const WIKI_WRITE_YOUR_FIRST_EXPERIENCE = "Bu\u010f prvn\u00ed a napi\u0161 hodnocen\u00ed";
